import type { Data } from '@strapi/types';
import { useQuery } from '@tanstack/react-query';

import { getReleaseNotes } from '../api/release-notes.api';

export const useReleaseNotesInit = (documentId: Data.DocumentID) => {
	const {
		data: releaseNotes,
		error,
		isPending,
	} = useQuery({
		queryKey: ['GET_RELEASE_NOTES', documentId],
		queryFn: () => getReleaseNotes({ documentId }),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		enabled: !!documentId,
	});

	return {
		releaseNotes,
		isPending,
		error,
	};
};
